import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function CaseStudies() {
  return <section className="py-20 bg-white" data-id="element-25">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <span className="inline-block px-4 py-1 bg-[#f5f3ff] text-[#7c3aed] text-sm font-medium rounded-full mb-4 border border-[#a78bfa] shadow-sm" data-id="element-28">
            Success Stories
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-29">
            Real results from event organizers
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-30">
            See how conferences are transforming attendee engagement with Nexio
            App
          </p>
        </div>
        <div className="bg-[#f8fafc] rounded-2xl overflow-hidden shadow-lg border-2 border-[#7c3aed]" data-id="element-31">
          <div className="md:flex" data-id="element-32">
            <div className="md:w-2/5 bg-[#f5f3ff] p-8 flex items-center border-4 border-[#7c3aed] rounded-lg shadow-md" data-id="element-33">
              <div data-id="element-34">
                <span className="inline-block px-3 py-1 bg-[#7c3aed] text-white text-sm font-medium rounded-full mb-4 shadow-sm" data-id="element-35">
                  Case Study
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-36">
                  TechConf Europe 2024
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-37">
                  How a 2,000-attendee tech conference transformed Q&A sessions
                  and doubled speaker application quality
                </p>
                <div className="flex items-center text-[#7c3aed] font-medium" data-id="element-38">
                  <span data-id="element-39">Medium Plan ($69/month)</span>
                </div>
              </div>
            </div>
            <div className="md:w-3/5 p-8 border-l-2 border-[#7c3aed] bg-white shadow-sm" data-id="element-40">
              <div className="mb-6 p-5 border-2 border-[#7c3aed] rounded-lg shadow-md hover:shadow-md transition-shadow bg-white" data-id="element-41">
                <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-42">
                  The Challenge
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-43">
                  <li data-id="element-44">Q&A sessions dominated by the same vocal attendees</li>
                  <li data-id="element-45">Speaker applications scattered across email threads</li>
                  <li data-id="element-46">No way to gauge community interest in proposed topics</li>
                  <li data-id="element-47">Speakers frustrated by lack of submission updates</li>
                </ul>
              </div>
              <div className="mb-6 p-5 border-2 border-[#7c3aed] rounded-lg shadow-md hover:shadow-md transition-shadow bg-white" data-id="element-48">
                <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-49">
                  Results After Implementation
                </h4>
                <ul className="space-y-2" data-id="element-50">
                  <li className="flex items-start" data-id="element-51">
                    <CheckIcon className="h-5 w-5 text-[#10b981] mr-2 flex-shrink-0" data-id="element-52" />
                    <span className="text-gray-600" data-id="element-53">
                      350+ questions collected, 85% from first-time participants
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-54">
                    <CheckIcon className="h-5 w-5 text-[#10b981] mr-2 flex-shrink-0" data-id="element-55" />
                    <span className="text-gray-600" data-id="element-56">
                      40% increase in speaker application quality
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-57">
                    <CheckIcon className="h-5 w-5 text-[#10b981] mr-2 flex-shrink-0" data-id="element-58" />
                    <span className="text-gray-600" data-id="element-59">
                      Community voted on 12 session topics, driving 30% higher
                      attendance
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-60">
                    <CheckIcon className="h-5 w-5 text-[#10b981] mr-2 flex-shrink-0" data-id="element-61" />
                    <span className="text-gray-600" data-id="element-62">
                      Saved 15+ hours of organizing team time
                    </span>
                  </li>
                </ul>
              </div>
              <div className="italic text-gray-600 border-2 border-[#7c3aed] border-l-4 border-l-[#10b981] pl-4 p-5 rounded-lg shadow-md mb-6 bg-[#f9f9f9]" data-id="element-63">
                "Nexio completely changed how we engage with our community. Our
                panels are more dynamic, our speakers feel valued, and attendees
                are genuinely excited to participate. It is not just a tool—it
                is how we build better conferences."
                <div className="mt-2 font-medium not-italic" data-id="element-64">
                  — Sarah Mitchell, TechConf Europe Director
                </div>
              </div>
              <Button variant="outline" className="flex items-center" data-id="element-65">
                Read full case study{' '}
                <ArrowRightIcon className="ml-2" size={16} data-id="element-66" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}